<template>
  <div>
    <ValidationProvider
      v-if="hasValidator"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors, valid }">
        <b-field
          v-bind="$attrs"
          :type="{ 'is-danger': errors[0], 'is-success': valid }"
          :message="errors">
            <b-taginput
                v-model="selected"
                :data="filterTypes"
                autocomplete
                :open-on-focus="true"
                field="name"
                type="is-primary"
                :maxtags="1"
                :has-counter="false"
                icon="label"
                placeholder="Selecciona un tipo"
                @typing="type = $event" :loading="isLoading">
                <template slot-scope="props">
                  <span>{{props.option.name}}</span>
                </template>
            </b-taginput>
        </b-field>
    </ValidationProvider>
    <b-taginput
      v-else
      v-model="selected"
      :data="filterTypes"
      autocomplete
      :open-on-focus="true"
      field="name"
      type="is-primary"
      :maxtags="1"
      :has-counter="false"
      icon="label"
      placeholder="Selecciona un Caballo"
      @typing="type = $event" :loading="isLoading">
        <template slot-scope="props">{{props.option.name}}</template>
    </b-taginput>
  </div>
</template>

<script>
import OffDayTypeService from '@/services/OffDayTypeService'

export default {
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    hasValidator: {
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      default: null,
      type: Number
    }
  },
  created () {
    this.getTypes()
  },
  data () {
    return {
      type: '',
      selected: null,
      types: [],
      isLoading: false
    }
  },
  methods: {
    async getTypes () {
      this.isLoading = true
      let response = await OffDayTypeService.getTypes()
      this.types = response.data.data

      if (this.value) {
        this.selected = this.types.filter((x) => x.id === this.value)
      }
      this.isLoading = false
    }
  },
  computed: {
    filterTypes () {
      return this.types.filter((type) => {
        return `${type.name}`
          .toString()
          .toLowerCase()
          .indexOf(this.type.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    selected () {
      this.$emit('select', this.selected[0])
    }
  }

}
</script>
